<ng-container *ngIf="loading">
    <img src="/assets/images/loading_precotizacion.gif" alt="Icon">
    <sc-title content="Estamos enviando tu solicitud de aprobación" type="h2" class="approval-request__title"></sc-title>
</ng-container>
<ng-container *ngIf="!loading">
    <ng-container *ngIf="!requestSent">
        <img src="/assets/images/issue-alert.png" class="approval-request__icon" alt="Icon">
        <sc-title content="El endoso posee pautas de suscripción que requieren aprobación" type="h2" class="approval-request__title"></sc-title>
        <div class="approval-request__underwriting-messages">
            <p class="approval-request__underwriting-messages__title">Pautas de suscripción:</p>
            <ul>
                <li class="approval-request__underwriting-messages__item" *ngFor="let item of underwritingMessages">{{ item }}</li>
            </ul>
        </div>
        <div class="approval-request__buttons">
            <sc-button class="mr-1" (onClick)="handleContinue()">Solicitar aprobación</sc-button>
            <sc-button type="secondary" (onClick)="handleCancel()">Modificar el endoso</sc-button>
        </div>
    </ng-container>
    <ng-container *ngIf="requestSent">
        <img src="/assets/images/emision-poliza.png" class="approval-request__icon" alt="Icon">
        <sc-title content="El endoso se encuentra en revisión" type="h2" class="approval-request__title"></sc-title>
        <p class="approval-request__sent-message">
            Te avisaremos por medio de las notificaciones sobre la aprobación o rechazo de las pautas de suscripción
        </p>
        <div class="approval-request__buttons">
            <sc-button (onClick)="handleBack()">Volver a la póliza</sc-button>
        </div>
    </ng-container>
</ng-container>